import { TypedEmitter } from "tiny-typed-emitter";
const EventBus = new TypedEmitter();
export default EventBus;
